module.exports = __webpack_public_path__ + "img/symbol_6.847e75f9.png";